import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { HelpBlock } from 'react-bootstrap';
import { Field } from 'redux-form';
import masterField from '../../../../../components/search-form/master-field';
import renderField from './render-field';

const lookbackPeriods = [
  { value: 14, label: '14 Days' },
  { value: 30, label: '30 Days' },
  { value: 45, label: '45 Days' },
  { value: 60, label: '60 Days' },
  { value: 75, label: '75 Days' },
  { value: 90, label: '90 Days' },
];

class LookbackField extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  render() {
    return (
      <div>
        <Field
          name="full_automation_lookback_period"
          componentClass="select"
          options={lookbackPeriods}
          component={renderField}
          disabled={this.props.disabled}
        />
        <HelpBlock>Only opportunity owner activities that occurred between the opportunity close date and the lookback period will be considered.</HelpBlock>
      </div>
    );
  }
}

LookbackField.propTypes = {
  value: PropTypes.bool,
  disabled: PropTypes.bool,
  submitting: PropTypes.bool,
  onChange: PropTypes.func,
};
LookbackField.defaultProps = {
  value: false,
  disabled: false,
  submitting: false,
};
export default masterField(LookbackField);
